/**
 * 결제 호출에 고객 토큰을 싣는다.
 *
 * `api.ts` 의 기본 Authorization 헤더는 `localStorage.accessToken`(백오피스 스태프)만 읽는다.
 * 고객 토큰은 `sessionStorage.accessCustomerToken` 에 있어서, 결제 API 는 지금까지 토큰 없이
 * 나가고 주문의 주인을 **본문의 `customerId`** 로만 말해 왔다. 그래서 아무나 남의 고객 ID 를
 * 적어 그 계정에 주문을 붙일 수 있었다 (judahsWeb/SECURITY.md B1).
 *
 * 서버는 토큰이 오면 그것을 주인으로 삼고, 안 오면 본문 값으로 물러난다. 이 헤더가 붙는 순간
 * 위조 경로가 닫힌다. 비회원 결제는 그대로다 — 토큰이 없으면 빈 객체를 돌려준다.
 */
export const checkoutAuthHeaders = (): { Authorization?: string } => {
	try {
		const customerToken: string = sessionStorage.getItem('accessCustomerToken') ?? ''

		return customerToken === '' ? {} : { Authorization: `Bearer ${customerToken}` }
	} catch (error) {
		// 저장소가 막힌 환경 — 비회원으로 결제한다
		return {}
	}
}
